(function() {
  'use strict';

  function restructureKachingBars() {
    const bars = document.querySelectorAll('.kaching-bundles__bar');
    if (bars.length === 0) return;
    
    bars.forEach(bar => {
      if (bar.dataset.restructured === 'true') return;
      
      const label = bar.querySelector('.kaching-bundles__bar-label');
      const subtitle = bar.querySelector('.kaching-bundles__bar-subtitle');
      const pricingPrimary = bar.querySelector('.kaching-bundles__bar-pricing-row--primary');
      const pricingSecondary = bar.querySelector('.kaching-bundles__bar-pricing-row--secondary');
      const container = bar.querySelector('.kaching-bundles__bar-container');
      const titleEl = bar.querySelector('.kaching-bundles__bar-title');
      const badgeOriginal = bar.querySelector('.kaching-bundles__bar-most-popular__content');
      
      if (!label || !subtitle || !pricingPrimary) return;
      
      const labelText = label.textContent.trim();
      const subtitleText = subtitle.textContent.trim();
      
      // Beschriftung splitten: "0,22 € / Portion · Spare 5%"
      const labelParts = labelText.split('·').map(s => s.trim());
      const portionPrice = labelParts[0] || '';
      const savingsText = labelParts[1] || '';
      
      // Untertitel splitten: "90 Portionen · 5% sparen" → nur "90 Portionen"
      const subtitleParts = subtitleText.split('·').map(s => s.trim());
      const portionCount = subtitleParts[0] || '';
      
      // Untertitel: "90 Portionen · 0,22 € / Portion"
      if (portionPrice) {
        subtitle.textContent = portionCount + ' · ' + portionPrice;
      } else {
        subtitle.textContent = portionCount;
      }
      
      label.style.display = 'none';
      
      // Spare-Pill direkt neben den Titel einfügen (ohne Häkchen)
      if (savingsText && titleEl && !bar.querySelector('.jh-spare-pill')) {
        const sparePill = document.createElement('span');
        sparePill.className = 'jh-spare-pill';
        sparePill.textContent = savingsText;
        titleEl.parentNode.insertBefore(sparePill, titleEl.nextSibling);
      }
      
      // Bestseller Badge als Eck-Flagge — OHNE Stern
      if (badgeOriginal && container && !container.querySelector('.jh-corner-badge')) {
        const badgeText = badgeOriginal.textContent.trim();
        if (badgeText && badgeText.toLowerCase().includes('bestseller')) {
          const cornerBadge = document.createElement('div');
          cornerBadge.className = 'jh-corner-badge jh-corner-badge--primary';
          cornerBadge.textContent = badgeText;
          container.appendChild(cornerBadge);
        }
      }
      
      bar.dataset.restructured = 'true';
    });
  }

  let pollAttempts = 0;
  const pollInterval = setInterval(function() {
    pollAttempts++;
    if (document.querySelectorAll('.kaching-bundles__bar').length > 0) {
      restructureKachingBars();
      clearInterval(pollInterval);
      
      const container = document.querySelector('.kaching-bundles');
      if (container) {
        const observer = new MutationObserver(function() {
          restructureKachingBars();
        });
        observer.observe(container, {
          childList: true,
          subtree: true
        });
      }
    } else if (pollAttempts > 50) {
      clearInterval(pollInterval);
    }
  }, 200);
})();